import React from "react";
import { Link } from 'react-router-dom'
import "../App.css";
import Post from "./Post";
import "./ContributionPage.css";
import Contribution from "./Contribution";
import ContributionSidebar from "./ContributionSidebar";
import EditStory from "./EditStory";
import ArtworkMini from "./ArtworkMini";

export default class ContributionPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.postId,
            post: null,
            sortbyHidden: true,
            //create story stuff
            popup: true,
            title: "Title",
            prevTitle: "Title",
            story: "",
            prevStory: "Public",
            prevText: "Text",
            users: [],
            contributions: [],
            sortValue: "Recent",
            sortIndex: 0,
            generalerror: false,
        };
        this.locatePosition.bind(this);
    }

    displaySortByFilters() {
        this.setState({
            sortbyHidden: !this.state.sortbyHidden
        })
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_PATH + "/posts/" + this.state.id, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then(res => {

                if (!res.ok) {
                    this.setState({
                        generalerror: true,
                    });
                    return;
                }
                return res.json();
            })
            .then(
                response => {
                    this.setState({
                        post: response,
                    })
                    fetch(process.env.REACT_APP_API_PATH + "/connections?fromUserID=" + sessionStorage.getItem('user') + "&toUserID=" + response.author.id, {
                        method: "get",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("token")
                        }
                    })
                        .then(res => {

                            if (!res.ok) {
                                this.setState({
                                    generalerror: true,
                                });
                                return;
                            }
                            return res.json();
                        })
                        .then(
                            result => {
                                if (result[1] > 0) {
                                    if (result[0][0].attributes.type === "blocking") {
                                        this.setState({
                                            blocked: true
                                        })
                                    }
                                }
                            },
                            error => {
                                this.setState({
                                    isLoaded: true,
                                    error
                                });
                                console.log("ERROR loading Posts")
                            }
                        )
                }
            )

        fetch(process.env.REACT_APP_API_PATH + "/post-reactions?postID=" + this.state.id + "&name=contribution", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then(res => {

                if (!res.ok) {
                    this.setState({
                        generalerror: true,
                    });
                    return;
                }
                return res.json();
            })
            .then(
                result => {
                    if (result) {
                        let sortedResult = result[0]
                        if (this.state.sortIndex === 0) {
                            this.setState({
                                contributions: sortedResult.reverse()
                            })
                        }
                        else if (this.state.sortIndex === 1) {
                            this.setState({
                                contributions: sortedResult
                            })
                        }
                        else if (this.state.sortIndex === 2) {
                            sortedResult = sortedResult.sort((a, b) => (b.value - a.value))
                        }
                        else if (this.state.sortIndex === 3) {
                            sortedResult = sortedResult.sort((a, b) => (a.value - b.value))
                        }
                    }
                }
            )

        fetch(process.env.REACT_APP_API_PATH + "/users", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then(res => {

                if (!res.ok) {
                    this.setState({
                        generalerror: true,
                    });
                    return;
                }
                return res.json();
            })
            .then(
                result => {

                    result[0].sort(function (a, b) {
                        return b.attributes.totalLikes - a.attributes.totalLikes;
                    });
                    if (result) {
                        this.setState({
                            users: result[0].slice(0, 6) || []
                        });
                    }
                }
            );

    }

    //CREATE STORY STUFF
    popUp() {
        this.setState({
            popup: !this.state.popup,
            title: "Title",
            prevTitle: "Title",
            story: "",
            prevText: "Text",
        })
    }
    titleChangeHandler = event => {
        this.setState({
            title: event.target.value,
            prevTitle: event.target.value
        });
    };
    storyChangeHandler = event => {
        this.setState({
            story: event.target.value,
            prevStory: event.target.value
        });
    };

    locatePosition(number) {
        let compare = "", ret = "";
        compare = String(number);

        if (compare[compare.length - 1] === '1') {
            if (compare.length > 1) {
                if (compare[compare.length - 2] === '1') {
                    ret = "th";
                } else {
                    ret = "st";
                }
            } else {
                ret = "st";
            }
        } else if (compare[compare.length - 1] === '2') {
            ret = "nd";
        } else if (compare[compare.length - 1] === '3') {
            ret = "rd";
        } else {
            ret = "th";
        }
        return ret;
    }

    submitContribution = event => {
        // fetch(process.env.REACT_APP_API_PATH+"/post-reactions", {
        //     method: "POST",
        //     headers: {
        //       'Content-Type': 'application/json',
        //       'Authorization': 'Bearer '+sessionStorage.getItem("token")
        //     },
        //     body: JSON.stringify({
        //         postID: this.state.post.id,
        //         reactorID: sessionStorage.getItem("user"),
        //         name: "contribution",
        //         content: this.state.story,
        //         value: 0,
        //         attributes:{
        //             title: this.state.title,
        //             content: this.state.story 
        //         }
        //     })
        //   }).then(updateState => {
        //     this.setState({
        //         popup: true,
        //         advanced:true,
        //         prevTitle: "Title",
        //         prevStory:"Text"
        //       })
        //   })

        fetch(process.env.REACT_APP_API_PATH + "/post-reactions", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
            body: JSON.stringify({
                postID: this.state.post.id,
                reactorID: sessionStorage.getItem("user"),
                name: "contribution",
                content: this.state.story,
                value: 0,
                attributes: {
                    title: this.state.title,
                    content: this.state.story,
                    reactions: []
                }
            })
        })
            .then(
                res => {
                    if (!res.ok) {
                        this.setState({
                            generalerror: true,
                        });
                        return;
                    }
                    this.setState({
                        popup: true,
                        advanced: true,
                        prevTitle: "Title",
                        prevStory: "Text",
                        title: "Title",
                        story: ""
                    })
                    window.location.reload();
                }
            )
    }

    alterFilterRecent() {
        this.setState({
            sortbyHidden: !this.state.sortbyHidden,
            sortValue: "Recent",
            sortIndex: 0
        }, () => {
            this.callToUpdate();
        })
    }
    alterFilterOldest() {
        this.setState({
            sortbyHidden: !this.state.sortbyHidden,
            sortValue: "Oldest",
            sortIndex: 1
        }, () => {
            this.callToUpdate();
        })
    }
    alterFilterMost() {
        this.setState({
            sortbyHidden: !this.state.sortbyHidden,
            sortValue: "Most Upvotes",
            sortIndex: 2
        }, () => {
            this.callToUpdate();
        })
    }
    alterFilterLeast() {
        this.setState({
            sortbyHidden: !this.state.sortbyHidden,
            sortValue: "Least Upvotes",
            sortIndex: 3
        }, () => {
            this.callToUpdate();
        })
    }

    //<input type="submit" value="Create Contribution!" className="archivedStoriesButton" onClick={this.popUp.bind(this)}/>
    //<div className="archivedStoriesButton" onClick={this.popUp.bind(this)}>Create Contribution!</div>
    callToUpdate() {
        fetch(process.env.REACT_APP_API_PATH + "/post-reactions?postID=" + this.state.id + "&name=contribution", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then(res => {

                if (!res.ok) {
                    this.setState({
                        generalerror: true,
                    });
                    return;
                }
                return res.json();
            })
            .then(
                result => {
                    if (result) {
                        let sortedResult = result[0]
                        if (this.state.sortIndex == 0) {
                            this.setState({
                                contributions: sortedResult.reverse()
                            })
                        }
                        else if (this.state.sortIndex == 1) {
                            this.setState({
                                contributions: sortedResult
                            })
                        }
                        else if (this.state.sortIndex == 2) {
                            this.setState({
                                contributions: sortedResult.sort((a, b) => (b.value - a.value))
                            })
                        }
                        else if (this.state.sortIndex == 3) {
                            this.setState({
                                contributions: sortedResult.sort((a, b) => (a.value - b.value))
                            })
                        }
                    }
                }
            )
    }
    render() {
        return (
            <div className="postPage">
                {!this.state.popup ? <div className="contribution-modal-container">
                    <div className="contrib-StoryBox">
                        <div className="contrib-createHeaderT">Create a Contribution</div>
                        {this.state.generalerror ? <div className="innerError">An error has happened that is not your fault. Reload the page.</div> : ""}
                        <div className="contrib-titleInput">
                            <input className="contrib-titleField" placeholder={this.state.prevTitle} onChange={this.titleChangeHandler} />
                        </div>
                        <div className="contrib-storyInputBox">
                            <textarea className="contrib-storyInput" value={this.state.story} placeholder={this.state.prevText} onChange={this.storyChangeHandler} />
                        </div>
                        <div className="contrib-footerStory">
                            <div className="contrib-submissionBox">
                                <button className="contrib-PostButton" onClick={this.submitContribution}>Post</button>
                                <button className="contrib-CancelButton" onClick={this.popUp.bind(this)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div> : ""}


                {this.state.post ?
                    <div className="postPageBody">
                        <div className="postMain">
                            {this.state.generalerror ? <div className="innerError">An error has happened that is not your fault. Reload the page.</div> : ""}
                            <div className="postParent">

                                <Post childrenCount={this.state.post._count["children"]} onHomepage={false} key={this.state.id} post={this.state.post} type={this.props.type} loadPosts={_ => {}} comment={false} />
                            </div>
                            <div className='sortbyBox'>
                                <div className = "sortByLab">
                                    <label>Sort By: </label>
                                    <div className="sortByDropdown">
                                        {this.state.sortbyHidden &&
                                            <button class="sortbyButton" onClick={this.displaySortByFilters.bind(this)}>{this.state.sortValue}</button>
                                        }
                                        {!this.state.sortbyHidden &&
                                            <div class="sortByFilters">
                                                <a onClick={this.alterFilterRecent.bind(this)} href="#recent" className="topfilter">Recent</a>
                                                <a onClick={this.alterFilterOldest.bind(this)} href="#oldest">Oldest</a>
                                                <a onClick={this.alterFilterMost.bind(this)} href="#most">Most Upvotes</a>
                                                <a onClick={this.alterFilterLeast.bind(this)} href="#least" className="bottomfilter">Least Upvotes</a>
                                            </div>
                                        }
                                    </div>
                                    </div>
                                </div>
                            <div className="postContributions">
                                {!this.state.blocked ? this.state.contributions.map(c => { return (<Contribution key={c.id} post={c} />) }) : ''}
                            </div>
                        </div>


                        <div className="rightContentBox">
                            <input type="submit" value="Create Contribution!" className="contStoriesButton" onClick={this.popUp.bind(this)} />
                            <div className="leaderboardPreviewBox">
                                <div className="leaderboardPreviewTitle">
                                    <input type="submit" value="Leaderboard" className="leaderboardPreviewTitleButton" />
                                </div>
                                <div className="leaderboardPreviewContent">
                                    {this.state.users.map((user, index) => {
                                        return (
                                            <div className="leaderboardPreviewUser">
                                                <p className="leaderboardRank">
                                                    {index + 1}{this.locatePosition(index + 1)}
                                                </p>
                                                <Link to={"/user/" + user.id} className="storypic">
                                                    <img src={user.attributes.pfp}
                                                        height='35'
                                                        width='35'
                                                        className='leaderBoradStoryPic'
                                                        alt={user.attributes.username}
                                                    />
                                                </Link>
                                                <p className="leaderboardUserName">
                                                    {user.attributes.username}
                                                </p>
                                            </div>
                                        )
                                    })}
                                </div>
                                <Link to="/leaderboard">
                                    <input type="submit" value="View All" className="leaderboardPreviewViewAllButton" />
                                </Link>
                            </div>

                            { /* ------------------ ARTWORK ------------------ */}
                            <ArtworkMini postID={this.props.postId} />
                            { /* --------------------------------------------- */}

                        </div>


                    </div>
                    : <p className="postError">Post not found ;-(</p>
                }
            </div>
        );
    }
}
